// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.music-container {
    display: flex;
    overflow-y: scroll;
    flex-direction: column;
    padding: 20px;
    background: #f9f9f9;
    height: 100%;
  }
  
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    width: 390px;
    background: #f9f9f9;
    position: fixed;
    top: 0;
  }
  
  header h1 {
    font-size: 24px;
    font-weight: bold;
  }
  
  header button {
    padding: 8px 16px;
    font-size: 16px;
    background-color: #ff5a5f;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .songs-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 70px;
  }
  
  .song-item {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: white;
    cursor: pointer;
    display: flex;
    flex-direction: column;
  }
  
  .song-item:hover {
    background: #f0f0f0;
  }
  
  .song-info h2 {
    font-size: 18px;
    margin: 0;
  }
  
  .song-info p {
    margin: 0;
    color: #666;
  }
  
  .player {
    position: fixed;
    bottom: 0;
    width: 370px;
    background: #fff;
    padding: 10px;
    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  audio {
    width: 100%;
    margin-bottom: 5px;
  }
  
`, "",{"version":3,"sources":["webpack://./src/components/css/Music.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,MAAM;EACR;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,SAAS;IACT,WAAW;EACb;;EAEA;IACE,eAAe;IACf,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB","sourcesContent":[".music-container {\n    display: flex;\n    overflow-y: scroll;\n    flex-direction: column;\n    padding: 20px;\n    background: #f9f9f9;\n    height: 100%;\n  }\n  \n  header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n    width: 390px;\n    background: #f9f9f9;\n    position: fixed;\n    top: 0;\n  }\n  \n  header h1 {\n    font-size: 24px;\n    font-weight: bold;\n  }\n  \n  header button {\n    padding: 8px 16px;\n    font-size: 16px;\n    background-color: #ff5a5f;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .songs-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding-top: 70px;\n  }\n  \n  .song-item {\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: white;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .song-item:hover {\n    background: #f0f0f0;\n  }\n  \n  .song-info h2 {\n    font-size: 18px;\n    margin: 0;\n  }\n  \n  .song-info p {\n    margin: 0;\n    color: #666;\n  }\n  \n  .player {\n    position: fixed;\n    bottom: 0;\n    width: 370px;\n    background: #fff;\n    padding: 10px;\n    box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  audio {\n    width: 100%;\n    margin-bottom: 5px;\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
